import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Title } from '@fnacdarty/back-office-ui';
import TwoFactorHeadBand from '../TwoFactorHeadBand';

import { handleDoubleAuthLogin } from '../../utils/auth';

import {
	StyledCodeContainer,
	StyledContainer,
	StyledDescription,
	StyledFormContainer,
	StyledInput,
	StyledButton,
} from './index.styled';

const TwoFactorLogin = ({ closeMode, mfaToken, extraActionLogin }) => {
	const [codeInputs, setCodeInputs] = useState([
		{ value: '' },
		{ value: '' },
		{ value: '' },
		{ value: '' },
		{ value: '' },
		{ value: '' },
	]);

	const [status, setStatus] = useState({
		error: '',
		loading: false,
	});

	const handleInputChange = (e, index) => {
		const { value } = e.target;
		const list = [...codeInputs];
		list[index].value = value;
		setCodeInputs(list);
	};

	// handle paste event on the page
	useEffect(() => {
		const handlePaste = (e) => {
			const paste = (e.clipboardData || window.clipboardData).getData(
				'text',
			);
			const list = [...codeInputs];
			const pasteArray = paste.split('');
			pasteArray.forEach((item, index) => {
				list[index].value = item;
			});
			setCodeInputs(list);
		};
		document.addEventListener('paste', handlePaste);
		return () => {
			document.removeEventListener('paste', handlePaste);
		};
	}, [codeInputs]);

	// change focus on input
	useEffect(() => {
		const inputs = document.querySelectorAll('input');
		inputs.forEach((input, index) => {
			input.addEventListener('keyup', (e) => {
				if (e.keyCode === 8 && index !== 0) {
					inputs[index - 1].focus();
				} else if (e.keyCode !== 8 && index !== inputs.length - 1) {
					inputs[index + 1].focus();
				}
			});
		});
	}, []);

	// handle submit form
	const handleSubmit = async (e) => {
		e.preventDefault();
		setStatus({ ...status, loading: true, error: '' });
		const code = codeInputs.map((item) => item.value).join('');

		if (code.length !== 6) {
			setStatus({
				...status,
				error: 'Le code doit contenir 6 chiffres',
				loading: false,
			});
			return null;
		}

		const response = await handleDoubleAuthLogin({
			mfaToken,
			code,
		});

		if (!response.success) {
			setStatus({
				...status,
				error: response.error,
				loading: false,
			});
			return null;
		}

		const { token, refreshToken, user } = response.payload;
		return extraActionLogin(token, refreshToken, user);
	};

	return (
		<>
			<TwoFactorHeadBand closeMode={closeMode} />
			<StyledContainer>
				<Title level={3}>Code de vérification</Title>
				<StyledDescription>
					Merci de saisir le code de vérification qui vous a été
					envoyé par mail.
				</StyledDescription>
				<StyledFormContainer onSubmit={handleSubmit}>
					<StyledCodeContainer>
						{codeInputs.map((item, index) => (
							<StyledInput
								key={index}
								value={item.value}
								onChange={(e) => handleInputChange(e, index)}
								maxLength={1}
							/>
						))}
					</StyledCodeContainer>
					<StyledButton
						type="submit"
						loading={status.loading}
						disabled={status.loading}
					>
						{status.loading && 'Vérification en cours...'}
						{!status.loading && 'Vérifier'}
					</StyledButton>

					{status.error && (
						<StyledDescription
							style={{ color: 'red', marginTop: '12px' }}
						>
							{status.error}
						</StyledDescription>
					)}
				</StyledFormContainer>
			</StyledContainer>
		</>
	);
};

TwoFactorLogin.propTypes = {
	closeMode: PropTypes.func,
	mfaToken: PropTypes.string,
	extraActionLogin: PropTypes.func,
};

export default TwoFactorLogin;
